<template>
  <div class="popup-outer">
    <div class="popup-inner">
      <div class="popup-content">
        <div class="movie-tutorial">
          <div class="title-area">
            <p class="title">이제 영화 메뉴 내의<br>모든 영화를 마음껏 즐기세요.</p>
          </div>
          <div class="content-area">
            <div class="text-area">
              <p>별도 이용권으로 제공되었던<span>PLAYY 영화가 Wavvie 영화와 통합되어</span> Wavve 이용권*으로 볼 수 있는 영화가 더욱 풍성해졌어요.</p>
            </div>
            <div class="image-area">
              <img src="../../assets/images/img-movietag.png" alt="영화 포스터 뱃지 리스트 이미지">
            </div>
          </div>
        </div>
        <div class="notice-area">
          <ul class="notice-list">
            <li>Wavve 이용권&ast; &colon; Basic, Standard, Premium 및 그에 준하는 구 이용권</li>
            <li>별도로 운영되는 &lsquo;영화 플러스&rsquo;는 개별 구매 후 시청 가능합니다. &lsquo;영화 플러스&rsquo;는 영화 메뉴에서 제공되는 배너를 통해 이용할 수 있습니다.</li>
          </ul>
        </div>
      </div>
      <div class="popup-button-close">
        <a href="#" @click.prevent="close()">
          <img src="../../assets/images/btn-popup-close.png" alt="나가기">
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/common/util/utils'
import { URL_COOKIE_DOMAIN } from '@/common/constant'
import { PATH_NAME_MOVIE } from '@/common/router.const'
export default {
  name: 'WavviePopup',
  data () {
    return {
      isShowPopup: false
    }
  },
  props: {
    closeFn: {
      type: Function
    }
  },
  methods: {
    close () {
      let expires = new Date()
      expires.setDate(expires.getDate() + 365)
      utils.cookies.setItem('wavvie-popup', '1', expires.toUTCString(), URL_COOKIE_DOMAIN, '/')
      this.$router.push({ name: PATH_NAME_MOVIE })
    }
  }
}
</script>
<style scoped>
  .popup-outer img{
    width: 100%;
  }
  .popup-content{
    display: flex;
    flex-direction: column;
    justify-content: start;
    text-align: center;
  }
  .movie-tutorial{
    padding: 68px 20px;
  }
  .movie-tutorial p{
    font-size: 14px;
    line-height: 20px;
    color: #a5a5a5;
  }
  .movie-tutorial .title{
    font-size: 20px;
    line-height: 29px;
    color: #fff;
  }
  .movie-tutorial .text-area{
    padding: 16px 0 40px;
  }
  .movie-tutorial .text-area p{
    font-size: 14px;
    line-height: 20px;
    color: #a5a5a5;
  }
  .movie-tutorial .text-area p span{
    display: block;
    color: #3887ff;
  }
  .movie-tutorial .image-area{
    padding: 0 30px;
  }
  .notice-area{
    padding: 20px;
    background-color: #101010;
  }
  .notice-list li{
    position: relative;
    padding-left: 6px;
    font-size: 12px;
    line-height: 18px;
    color: #7e7e7e;
    word-break: break-all;
    text-align: left;
  }
  .notice-list li + li{
    margin-top: 4px;
  }
  .notice-list li::before{
    content: '';
    display: inline-block;
    position: absolute;
    top: 9px;
    left: 0;
    width: 1px;
    height: 1px;
    border: 1px #7e7e7e solid;
    border-radius: 50%;
  }
  .popup-button-close{
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 1;
    width: 24px;
    height: 24px;
  }
  .popup-button-close a{
    display: block;
    font-size: 0;
  }

  @media screen and (max-width: 360px){
    .movie-tutorial span[class^="tag-"] + span{
      font-size: 12px;
    }
  }
</style>
